export function displayUrl(url) {
  return String(url || "").replace(/^https?:\/\//i, "").replace(/^\/+/, "");
}

export function toFullUrl(input) {
  const trimmed = String(input || "").trim();
  if (!trimmed) return "";
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}
